import { watch } from 'vue'
import { useTheme } from 'vuetify'
import { useLayoutStore } from '@/core/stores/layout'

export function useAppTheme() {
  const layoutStore = useLayoutStore()
  const vuetifyTheme = useTheme()

  // Sync theme with Vuetify
  watch(
    () => layoutStore.theme,
    (newTheme) => {
      vuetifyTheme.global.name.value = newTheme
    },
    { immediate: true },
  )

  return {
    theme: layoutStore.theme,
    isDark: layoutStore.isDark,
    toggleTheme: layoutStore.toggleTheme,
    setTheme: layoutStore.setTheme,
  }
}
